import { createAsyncThunk } from "@reduxjs/toolkit";

import { Api } from "../..";
import { CustomAction } from "../../store/customAction";
import {
  API_GET_ALL_LOGIN_ACTIVITY,
  API_GET_LOGIN_ACTIVITY_BY_FILTER,
} from "../../Apis/ApiEndPoints";
import { IAllLoginActivityResponse } from "../../models/admin/loginActivity/loginActivity";
import { FilterState } from "./LoginActivity";

export const getLoginActivity = createAsyncThunk(
  "all/loginActivity",
  async (_, { dispatch }) => {
    const response: IAllLoginActivityResponse = await CustomAction(
      Api.get(API_GET_ALL_LOGIN_ACTIVITY),
      dispatch,
      "all/loginActivity"
    );

    return response;
  }
);

export const getLoginActivityByFilter = createAsyncThunk(
  "all/loginActivityByFilter",
  async (filters: FilterState, { dispatch }) => {
    const {
      userType,
      deviceType,
      browserType,
      activityType,
      startDate,
      endDate,
      quickFilter,
    } = filters;

    const queryParams = new URLSearchParams();

    // Append multiple values separately
    userType?.forEach((type) => queryParams.append("userTypes", type));
    deviceType?.forEach((type) => queryParams.append("deviceTypes", type));
    browserType?.forEach((type) => queryParams.append("browserTypes", type));
    activityType?.forEach((type) => queryParams.append("activityTypes", type));

    if (startDate) queryParams.append("fromDate", startDate);
    if (endDate) queryParams.append("toDate", endDate);

    // Add quickFilter to the query parameters
    if (quickFilter) queryParams.append("quickFilters", quickFilter);

    const response: IAllLoginActivityResponse = await CustomAction(
      Api.get(`${API_GET_LOGIN_ACTIVITY_BY_FILTER}?${queryParams.toString()}`),
      dispatch,
      `all/loginActivityByFilter`
    );
    return response;
  }
);
